import { calcSlicesRect } from './calcSlicesRect';
import { calcCellSize } from './calcCellSize';
export function alignSlices(slices, rect) {
    rect = rect || calcSlicesRect();
    var sumGridSize = slices[0].gridSize + slices[1].gridSize + slices[2].gridSize;
    var cellSize = Math.min(Math.floor(rect.w / (sumGridSize + 2)), calcCellSize());
    var sum = 0;
    for (var i = 0; i < slices.length; i++) {
        slices[i].pos.x = rect.x + sum;
        slices[i].pos.y = rect.y;
        slices[i].cellSize = cellSize;
        sum += (slices[i].gridSize + 1) * cellSize;
    }
}
